import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { EtiquetaGerarDadosTesteRequest } from '../../requests/etiqueta/etiqueta-gerar-dados-teste.request';
import { EtiquetaImprimirRequest } from '../../requests/etiqueta/etiqueta-imprimir.request';
import { GerarDadosTesteEtiquetaResponse } from '../../responses/etiqueta/gerar-dados-teste-etiqueta.response';
import { ImprimirEtiquetaResponse } from '../../responses/etiqueta/imprimir-etiqueta.response';

@Injectable({
  providedIn: 'root',
})
export class ImpressaoEtiquetaService extends CommonService {
  private readonly apiUrl: string = environment.urlApiEtiqueta + 'ImpressaoEtiqueta';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public gerarDadosTeste(
    request: EtiquetaGerarDadosTesteRequest
  ): Observable<GerarDadosTesteEtiquetaResponse> {
    const url = `${this.apiUrl}/gerar-dados-teste`;

    return this.httpClient
      .post<GerarDadosTesteEtiquetaResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public gerarPreview(request: EtiquetaImprimirRequest): Observable<ImprimirEtiquetaResponse> {
    const url = `${this.apiUrl}/gerar-html`;

    return this.httpClient
      .post<ImprimirEtiquetaResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public gerarPdf(request: EtiquetaImprimirRequest): Observable<Blob> {
    const url = `${this.apiUrl}/gerar-pdf`;

    return this.httpClient
      .post(url, request, { ...this.addHeaderToken(), responseType: 'blob' })
      .pipe(catchError(this.handleError));
  }
}
